import { ReactNode } from "react";

export enum SortDirectionType {
  ASC = "ASC",
  DESC = "DESC",
}

export enum SortType {
  DATE = "DATE",
  NAME = "NAME",
}

export enum DisplayType {
  LIST,
  GRID,
  ACCORDION,
}

interface Pageable {
  pageNumber: number
  size: number
  last: boolean
}

export interface SliceResponse<T = unknown> {
  content: T[]
  pageable: Pageable
}

export type ListingDetailsProps<T> = {
  endpoint: string;
  additionalParams?: Record<string, string>;
  renderItem: (item: T, viewMode: ViewMode) => React.ReactNode;
  pageSize?: number;
  defaultSortField?: SortType;
  defaultSortDirection?: SortDirectionType;
  sortOptions?: { label: string; value: string }[];
  displaySearch?: boolean;
  searchPlaceholder?: string;
  initialViewMode?: ViewMode;
  tableColumns?: { key: string; label: string; align?: string }[];
  title?: string;
  filter?: ReactNode;
  pagination?: boolean
  refreshTrigger?: boolean;
  onError?: (message: string) => void;
  gridItemClassName?: string
  mobileGridItemClassName?: string
};

export type ViewMode = DisplayType;

export type ListCardField = {
  key: string
  label: ReactNode
  value: ReactNode
  mono?: boolean
  wide?: boolean
}

export type ListCardStripe =
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'neutral'
